

import { useEffect, useRef, useState } from 'react';
import { Button, IconButton } from '@mui/material';

import SVGComponent from '../../../../../Components/SVGComponent';

import { fn } from '../../../../../Functions';

import './TitleInformation.scss';

const TitleInformation = ({ serviceId, titleId, title }:{ serviceId: string, titleId: string, title: TitleType & TitleAugmentedData}) => {
    
    const [opacity, setOpacity] = useState<number>(0);
    const [isDescriptionOpen, setIsDescriptionOpen] = useState<boolean>(false);

    const targetRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        const scrollHandler = () => {
            const target = document.querySelector(".TitleInformationArea");

            const top = target?.getBoundingClientRect().top || 0;
            const bottom = target?.getBoundingClientRect().bottom || Infinity;

            setOpacity(Math.min(1, -top / (bottom - top)));
        };
        window.addEventListener("scroll", scrollHandler);

        return () => {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);

    if (!title) {
        return <></>;
    }

    const remained = {
        day: Math.floor(title.timeRemain / 86400),
        hour: Math.floor((title.timeRemain % 86400) / 3600),
        minute: Math.floor((title.timeRemain % 3600) / 60)
    };

    const progressPercent = `${Math.floor(title.timeRemain / (title.fullPeriod || 1) * 100)}%`;
    
    return (<div className={`TitleInformationArea`} ref={targetRef} >
        <div className={"TitleHomeHeader"} style={{backgroundColor: `rgba(255,255,255,${opacity})`}} >
            <IconButton className={"ClickIcon"} href={"/"} onClick={fn.gotoByAnchor} >
                <SVGComponent
                    src={"https://static.novela.today/icon/home.svg"}
                    width={20} height={20} 
                    color={`rgba(171, 170, 180, 1)`}
                />
            </IconButton>
            <IconButton className={"ClickIcon"} href={"/mypage"} onClick={fn.gotoByAnchor} >
                <SVGComponent
                    src={"https://static.novela.today/icon/user-profile.svg"}
                    width={20} height={20} 
                    color={"rgba(171, 170, 180, 1)"}
                />
            </IconButton>
        </div>
        <div className={"TitleHeaderBackdrop"}>
            <img src={title?.thumbnail} alt={`${title?.title}-image`} className={"HeaderBGImage"} />
        </div>
        <div className={"TitleInformationInner"} >
            <div className={`ThumbnailBackground`}  >
                <div className={`NovelThumbnail`}>
                    <img src={title?.thumbnail} alt={`${title?.title}-image`} className={"ThumbImage"} />
                </div>
                <div className={"NovelInfos"}>
                    <div className={"NovelTitle"} >
                        {title?.title}
                    </div>
                    <div className={"NovelInfo"} >
                        <span >
                            {[
                                ...title.tags.split(","),
                                title.is_finished ? "완결" : "연재중"
                            ].filter((item, index, array) => array.indexOf(item) === index)
                             .join(" · ")}
                        </span>
                        <span className={"Divider"}>{"|"}</span>
                        <span>{title.author}</span>
                    </div>
                </div>
                <div className={"NovelExtraInfo"} >
                    <div className={`DescriptionToc ${isDescriptionOpen ? "Open" : ""}`} >
                        <div className={'TocHeader'} >
                            <div className={"TocTitle"} >
                                <div className={"IconBox"} >
                                    <SVGComponent className={"MenuBookIcon"} src={"https://static.novela.today/icon/menu_book.svg"} width={14} height={14} />
                                </div>
                                <div className={"Title"}>{"줄거리"}</div>
                            </div>
                            <SVGComponent 
                                className={`ToggleSummary ${isDescriptionOpen ? "Open" : ""}`} 
                                src={"https://static.novela.today/icon/chevron_left_thick.svg"}
                                width={20} height={20} 
                                color={"rgba(174, 176, 185, 1)"}
                                onClick={() => setIsDescriptionOpen(!isDescriptionOpen)}    
                            />
                        </div>
                        {<div className={`TocContent ${isDescriptionOpen ? "Open" : "Close"}`} >
                            {title?.description}
                        </div>}
                    </div>
                    <div className={"ViewingRightBox"} >
                        <div className={"TitleBox"} >
                            <div className={"IconBox"} >
                                <SVGComponent className={"TimeLapsIcon"} src={"https://static.novela.today/icon/timelapse.svg"} width={14} height={14} />
                            </div>
                            <div className={"Title  "}>{"열람권 기간"}</div>
                        </div>
                        <div className={"RightPeriod"} >
                            {title.timeRemain === 0
                                ?<Button className={"ViewingRightPurchase"} onClick={() => fn.goto(`/payment/${serviceId}/${titleId}`)} >
                                    {"열람권 구매"}
                                </Button>
                                :<div className={"RemainingTime"} >
                                    <div className={"Time"}>
                                        {`${
                                            remained.day >0 ?`${remained.day}일`:``
                                        } ${
                                            remained.hour >0 ?`${remained.hour}시간`:``
                                        } ${
                                            remained.minute >0 ?`${remained.minute}분`:``
                                        } 남음`
                                        }
                                    </div>
                                    <div className={"ProgressContainer"} >
                                        <div className={"BaseBar"} />
                                        <div className={"ProgressBar"} style={{width: progressPercent}} />
                                    </div>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={`TitleInformationCover`} style={{opacity: isDescriptionOpen?0:opacity}} ></div>
    </div>)
}

export default TitleInformation;